import { Config } from './config';

// Also spread into gbifConfig, which reaches the route plugins before this default is merged in
export const envDefaults = {
  testSite: import.meta.env.PUBLIC_TEST_SITE === 'true',
  defaultMapChecklistKey: import.meta.env.PUBLIC_DEFAULT_CHECKLIST_KEY,
  hardcodedKeys: {
    OBISKey: import.meta.env.PUBLIC_KEYS_OBIS_NODE,
    taiwanNodeidentifier: import.meta.env.PUBLIC_KEYS_TAIWAN_PARTICIPANT,
  },
} satisfies Partial<Config>;

export const configDefault: Partial<Config> = {
  isGBIFOrg: false,
  ...envDefaults,
  defaultChecklistKey: import.meta.env.PUBLIC_DEFAULT_CHECKLIST_KEY,
  availableChecklistKeys: [import.meta.env.PUBLIC_DEFAULT_CHECKLIST_KEY], //import.meta.env.PUBLIC_SUPPORTED_CHECKLISTS?.split(',') || [],
  experimentalFeatures: {
    localContextEnabled: false,
    eventCoreEnabled: false,
  },
  feedback: {
    enabled: true,
    githubRepo: import.meta.env.PUBLIC_FEEDBACK_GITHUB_REPO,
  },
  openDrawerOnTableRowClick: true,
  availableCatalogues: [
    'OCCURRENCE',
    'INSTITUTION',
    'COLLECTION',
    'DATASET',
    'PUBLISHER',
    'TAXON',
    'LITERATURE',
  ],
  dataHeader: {
    enableApiPopup: true,
    enableInfoPopup: true,
  },
  datasetSearch: {
    excludedFilters: [],
    highlightedFilters: ['q', 'type', 'category', 'publishingOrg', 'license'],
    queryType: 'V1',
  },
  datasetKey: {
    occurrenceSearch: {
      excludedFilters: ['datasetKey'],
      // availableTableColumns: ['country', 'coordinates', 'year', 'basisOfRecord', 'dataset'],
      // defaultEnabledTableColumns: ['country', 'year', 'basisOfRecord', 'dataset'],
      tabs: ['table', 'map', 'gallery', 'download'],
      defaultTab: 'table',
    },
    literatureSearch: {
      highlightedFilters: ['q', 'year', 'countriesOfResearcher', 'dataset'],
    },
    enableListOfDownloads: false,
  },
  collectionSearch: {
    queryType: 'V1',
    highlightedFilters: [
      'q',
      'code',
      'country',
      'numberSpecimens',
      'occurrenceCount',
      'taxonKey',
      'descriptorCountry',
    ],
  },
  collectionKey: {
    occurrenceSearch: {
      // availableTableColumns: [
      //   'scientificName',
      //   'features',
      //   'country',
      //   'coordinates',
      //   'year',
      //   'eventDate',
      //   'basisOfRecord',
      //   'dataset',
      //   'publisher',
      //   'catalogNumber',
      //   'recordedBy',
      //   'identifiedBy',
      //   'recordNumber',
      //   'typeStatus',
      //   'preparations',
      //   'collectionCode',
      //   'institutionCode',
      //   'institutionKey',
      //   'collectionKey',
      //   'locality',
      //   'higherGeography',
      //   'stateProvince',
      //   'establishmentMeans',
      //   'iucnRedListCategory',
      // ],
      // defaultEnabledTableColumns: ['country', 'year', 'basisOfRecord', 'dataset'],
      tabs: ['table', 'map', 'gallery', 'clusters', 'download'],
      defaultTab: 'table',
      excludedFilters: [
        'occurrenceStatus',
        'networkKey',
        'hostingOrganizationKey',
        'protocol',
        'publishingCountryCode',
        'institutionCode',
        'institutionKey',
        'collectionCode',
        'collectionKey',
      ],
      highlightedFilters: [
        'taxonKey',
        'verbatimScientificName',
        'catalogNumber',
        'recordedBy',
        'identifiedBy',
      ],
      defaultEnabledTableColumns: [
        'features',
        'catalogNumber',
        'country',
        'year',
        'recordedBy',
        'identifiedBy',
      ],
    },
  },
  institutionSearch: {
    queryType: 'V1',
    highlightedFilters: ['q', 'code', 'country', 'numberSpecimens', 'occurrenceCount'],
  },
  institutionKey: {
    occurrenceSearch: {
      excludedFilters: [
        'occurrenceStatus',
        'networkKey',
        'hostingOrganizationKey',
        'protocol',
        'publishingCountryCode',
        'institutionCode',
        'institutionKey',
      ],
      highlightedFilters: [
        'taxonKey',
        'verbatimScientificName',
        'catalogNumber',
        'recordedBy',
        'identifiedBy',
        'collectionKey',
      ],
      availableTableColumns: [
        'scientificName',
        'commonName',
        'features',
        'media',
        'country',
        'coordinates',
        'year',
        'eventDate',
        'basisOfRecord',
        'datasetKey',
        'publishingOrg',
        'catalogNumber',
        'recordedBy',
        'identifiedBy',
        'recordNumber',
        'typeStatus',
        'preparations',
        'collectionCode',
        'institutionCode',
        'institutionKey',
        'collectionKey',
        'locality',
        'fieldNumber',
        'higherGeography',
        'stateProvince',
        'establishmentMeans',
        'sex',
        'lifeStage',
        'iucnRedListCategory',
      ],
      // defaultEnabledTableColumns: ['country', 'year', 'basisOfRecord', 'dataset'],
      tabs: ['table', 'gallery', 'map', 'dashboard', 'clusters', 'download'],
      defaultTab: 'table',
    },
  },
  publisherSearch: {
    queryType: 'V1',
    highlightedFilters: ['q', 'country'],
  },
  taxonSearch: {
    queryType: 'V1',
    highlightedFilters: ['q', 'status', 'rank', 'taxonId', 'issue'],
  },
  literatureSearch: {
    queryType: 'PREDICATE',
    highlightedFilters: ['q', 'year', 'countriesOfResearcher', 'gbifDatasetKey'],
  },
  eventSearch: {
    queryType: 'V1',
    highlightedFilters: [
      'humboldtProtocolNames',
      'humboldtBooleans',
      'year',
      'country',
      'geometry',
      'locality',
    ],
    tabs: ['table'],
  },
  occurrenceSearch: {
    queryType: 'PREDICATE',
    highlightedFilters: ['occurrenceStatus', 'taxonKey', 'year', 'country', 'issue', 'geometry'],
    tabs: ['table', 'gallery', 'map', 'download'],
    excludedFilters: [
      'endDayOfYear',
      'startDayOfYear',
      'associatedSequences',
      'previousIdentifications',
      'datasetName',
      'datasetId',
      'publishingCountry',
      'gbifRegion',
      'publishedByGbifRegion',
      'hostingOrganizationKey',
      'lastInterpreted',
      'protocol',
    ],
  },
  maps: {
    locale: 'en',
    mapStyles: {
      defaultProjection: 'MERCATOR',
      defaultMapStyle: 'NATURAL',
      options: {
        ARCTIC: ['NATURAL', 'BRIGHT'],
        PLATE_CAREE: ['NATURAL', 'BRIGHT', 'DARK'],
        MERCATOR: ['NATURAL', 'BRIGHT', 'SATELLITE', 'DARK'],
        ANTARCTIC: ['NATURAL', 'BRIGHT', 'DARK'],
      },
    },
  },
};
